import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Fragment, useRef, useMemo, useState } from 'react';
import { withTheme } from 'styled-components';

import { H3, H4, HorizontalSpacer, VerticalSpacer, Collapse } from 'components';
import {
    DashboardContainer,
    ArchVisionAdminNavPanel,
    MainContent,
    PanelTitle,
    CategoryName,
    PageContent,
    NavCollapseToggle,
    NavContent,
} from './styles';
import { archVisionAdminItems } from './AdminItems';
import { CardsContainer } from 'pages/Documentation/docStyles';

const ArchVisionAdminDashboard = withTheme(props => {
    const { theme } = props;
    const userDataStore = useSelector(state => state.userData);
    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;
    const selectedTheme = userDataStore.userPreferences.theme;
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const onArchVisionAdmin = pathname.includes('/archvision-admin');
    const ref = useRef();
    const navigate = useNavigate();
    const selectedPage = useMemo(() => archVisionAdminItems.find(item => item.path === pathname), [ pathname ]);
    const scrollToTop = () => ref.current?.scrollTo(0,0);
    const [ navCollapsed, setNavCollapsed ] = useState(false);

    const buildDashboardNav = () => {
        archVisionAdminItems.sort((a, b) => {
            return a.title.localeCompare(b.title);
        });

        return archVisionAdminItems.map((item, index) => (
            <Fragment key={index}>
                <CategoryName
                    key={index}
                    theme={theme}
                    $selectedTheme={selectedTheme}
                    $selected={pathname === item.path}
                    onClick={() => {
                        navigate(item.path);
                        if (item.action) {
                            dispatch(item.action(token));
                        }
                        scrollToTop();
                    }}
                >
                    <HorizontalSpacer size={25} />
                    {item.title}
                </CategoryName>
                <VerticalSpacer size={20} />
            </Fragment>
        ));
    };

    return (
        <DashboardContainer
            theme={theme}
            $selectedTheme={selectedTheme}
            $onArchVisionAdmin={onArchVisionAdmin}
            $navCollapsed={navCollapsed}
        >
            {onArchVisionAdmin && (
                <ArchVisionAdminNavPanel theme={theme} $selectedTheme={selectedTheme}>
                    <NavCollapseToggle $collapsed={navCollapsed} onClick={() => setNavCollapsed(!navCollapsed)}>
                        <Collapse color={theme.colors[selectedTheme].mediumGrey} rotate={navCollapsed ? 180 : 0} />
                    </NavCollapseToggle>
                    <NavContent $collapsed={navCollapsed}>
                        <PanelTitle>
                            <H4>Admin Dashboard</H4>
                        </PanelTitle>
                        <VerticalSpacer size={20} />
                        {buildDashboardNav()}
                    </NavContent>
                </ArchVisionAdminNavPanel>
            )}

            <MainContent ref={ref}>
                <CardsContainer theme={theme} $selectedTheme={selectedTheme} $onArchVisionAdmin={onArchVisionAdmin}>
                    {selectedPage &&
                        <PageContent>
                            <VerticalSpacer size={43} />
                            {!selectedPage.hideTitle && (
                                <>
                                    <H3>{selectedPage.title}</H3>
                                    <VerticalSpacer size={7} />
                                </>
                            )}
                            {selectedPage.element}
                        </PageContent>
                    }
                </CardsContainer>
            </MainContent>
        </DashboardContainer>
    );
});

export { ArchVisionAdminDashboard };